import { addStaticSplideClasses, sel, selAll } from './utils'
import '@splidejs/splide/css'
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import { Intersection } from '@splidejs/splide-extension-intersection'
import { lenis } from './lenis'
import scrollTracker from './ScrollTracker'

export default function Events() {
  // console.log('careers')

  function sliderInit() {
    const topSlider = sel('.team__top-slider')
    const bottomSlider = sel('.team__bottom-slider')
    addStaticSplideClasses(topSlider)
    addStaticSplideClasses(bottomSlider)

    const splideOptions = {
      perPage: 5,
      gap: '1.5rem',
      pagination: false,
      arrows: false,
      type: 'loop',
      drag: 'free',
      autoScroll: {
        speed: 0.2,
        pauseOnHover: false,
      },
      breakpoints: {
        1200: {
          perPage: 4,
          // gap: '1.5rem',
        },
        991: {
          perPage: 3,
          // gap: '1rem',
        },
        768: {
          perPage: 2,
        },
        478: {
          perPage: 1,
          // gap: '0.5rem',
        },
      },
    }
    const topSplide = new Splide(topSlider, splideOptions).mount({ AutoScroll })
    const bottomSplide = new Splide(bottomSlider, { ...splideOptions, direction: 'rtl' }).mount({ AutoScroll })

    // Scroll detection using ScrollTracker with automatic cleanup
    const SCROLL_FACTOR = 0.5

    // Register scroll handler and get cleanup function
    const cleanup = scrollTracker.onScroll((scrollData) => {
      const newSpeed = scrollData.dampedVelocity * SCROLL_FACTOR

      if (topSplide && bottomSplide) {
        const topPosition = topSplide.Components.Move.getPosition()
        const bottomPosition = bottomSplide.Components.Move.getPosition()
        topSplide.Components.Move.translate(topPosition - newSpeed)
        bottomSplide.Components.Move.translate(bottomPosition + newSpeed)
      }
    })

    // Return cleanup function for component unmounting
    return cleanup
  }

  // Get cleanup function and use it on page unload
  const cleanup = sliderInit()
}
